import React, { useState } from "react";
import ReactPlayer from 'react-player'

function ListItem({ sound }) {
  const [localSound] = useState(sound);

  return (
    <div className="row mb-4 ">
      <div className="col-lg-3 col-md-6 col-sm-12">
        <ReactPlayer url={localSound.linkmedia} width="100%" height="100%" />
      </div>
      <div className="col-lg-9 col-md-6 col-sm-12 d-flex flex-column justify-content-around">
        <div>
          <h6 className="fw-bold text-decoration-underline mt-3">{ localSound.title }</h6>
          <p className="small">
            { localSound.description }
          </p>
        </div>
        <p className="text-secondary small fst-italic">
          {
            `Publié le ${new Date(localSound.date).toLocaleDateString('fr-FR')}`
          }
        </p>
      </div>
    </div>
  );
}

export default ListItem;